var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9449_141493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.23479 22.238C10.3889 18.954 12.244 15.9602 14.6694 13.4676C17.0949 10.9749 20.0317 9.04407 23.273 7.81097C31.9526 4.70928 40.3624 6.88742 43.4199 15.7062C46.364 24.1971 36.8143 30.0037 38.0809 33.9152L39.3272 37.5225L27.2727 41.7862L25.4054 36.5846C23.3118 30.5709 32.4883 23.5053 31.2565 19.9044C30.3916 17.4208 27.6505 17.735 25.362 18.5447C22.5591 19.5434 20.063 23.5077 18.7498 26.9019L9.23479 22.238ZM34.5559 44.3683C39.1745 42.7326 43.4198 44.8204 44.7571 48.5722C46.0945 52.3239 44.0965 56.3699 39.2952 58.0289C37.449 58.7488 35.4012 58.7242 33.5807 57.9604C31.7603 57.1965 30.3085 55.7525 29.5296 53.9311C29.2362 52.975 29.1335 51.9691 29.2273 50.9709C29.3212 49.9727 29.6097 49.0018 30.0765 48.1137C30.5433 47.2256 31.1792 46.4377 31.9478 45.795C32.7164 45.1524 33.6027 44.6676 34.5559 44.3683Z",
    fill: "#3BC800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9449_141493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.132,
    height: 44.9227,
    fill: "white",
    transform: "translate(0 43.0972) rotate(-66.1198)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/green.d65372451d81326737d22eb8d92c0bdc.svg";
export { ForwardRef as ReactComponent };